import { useRef, type ReactNode } from "react";
import classnames from "classnames";

import style from "./style.module.scss";
import themes from "../../themes";
import { useWidth } from "../../../../../hooks";
import { ImageContainer } from "../../../../../media";
import type { PhotoBookOptions, PhotoValue } from "../../../../types";

interface CoverBackgroundProps {
  options: PhotoBookOptions;
  children?: ReactNode;
  className?: string;
  productId?: string;
  userId?: string;
  onChange?: (photo: PhotoValue) => void;
  isPreview?: boolean;
}

function CoverBackground({
  options,
  children,
  className,
  productId,
  userId,
  onChange,
  isPreview,
}: CoverBackgroundProps) {
  const selectedTheme = themes.find((theme) => theme.value === options.theme) || themes[0];
  const color = options.color ? options.color : selectedTheme ? selectedTheme.color : null;
  const ref = useRef<HTMLDivElement>(null);
  const height = useWidth(ref);

  return (
    <div
      ref={ref}
      className={classnames(style.container, className)}
      style={{ height: height ?? undefined }}
    >
      {onChange ? (
        <ImageContainer
          className={style.coverPhoto}
          image={options.coverPhoto}
          onChange={onChange}
          productId={productId}
          userId={userId}
          isPreview={isPreview}
          aspectRatio={1}
        />
      ) : (
        <div
          className={style.coverPhoto}
          style={options.coverPhoto ? { backgroundImage: `url("${options.coverPhoto}")` } : {}}
        />
      )}
      <div
        className={style.cover}
        style={{
          ...(color ? { backgroundColor: color } : {}),
          ...(selectedTheme
            ? {
                backgroundImage: `url("${selectedTheme.src}")`,
                maskImage: `url("${selectedTheme.mask}")`,
                WebkitMaskImage: `url("${selectedTheme.mask}")`,
                maskSize: "cover",
              }
            : {}),
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default CoverBackground;
